import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
// import { Row, Col } from 'react-bootstrap';
import Committeeleft from './Committeeleft';
import { Container, Row,Col } from 'react-bootstrap';
import Breadcrumb from '../../Breadcrumb/Main'
import { Table } from 'react-bootstrap';

function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title='Home' subtitle="Grievance Redressal Committee" />
            <section className="team-area fix p-relative pt-120 pb-80">
                <div className="container">
                    <div className="lower-content">

                        <Row>

                        <Col md={3} className='c-left custom-padding-color mb-4'>
                        <Committeeleft></Committeeleft>
                        </Col>
                
                        <Col md={9} className='c-right'>

                            
                                <h3 className='c-headline mb-3'>Grievance Redressal Committee for the Teaching and Non-Teaching Staff</h3>
                                <p className='c-lineheight2dot5'>The Grievance Redressal Committee for the Teaching and Non-Teaching Staff of the Institute is constituted as following:  </p>

                                {/* <Link className='c-link' to="icc@iittp.ac.in" target="_blank" >icc@iittp.ac.in </Link> */}

                                <Table bordered responsive className='mt-3'>
                                    <tbody>
                                        <tr>
                                            <td>
                                                <p>Prof. Venkata Ramana Badarla</p>
                                                <p>Dean, Administration & Finance </p>
                                            </td>
                                            <td>Chairperson</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Brig. (Dr.) K P krishna Kumar (Retd.)</p>
                                                <p>Registrar</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Prof. N. Venkaiah</p>
                                                <p>Dean, Faculty Affairs</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. K P Naveen</p>
                                                <p>Head of the Department, Electrical Engineering</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Dr. Pooja Vyavahare</p>
                                                <p>Assistant Professor, Electrical Engineering</p>
                                            </td>
                                            <td>Member</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>SC/ST/OBC/PWD representative</p>
                                                
                                            </td>
                                            <td>Invitee</td>
                                        </tr>

                                        <tr>
                                            <td>
                                                <p>Mr. Umesh Kumar Singh</p>
                                                <p>Assistant Registrar, Legal Cell</p>
                                            </td>
                                            <td>Invitee</td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <p>Deputy Registrar / Assistant Registrar</p>
                                                <p>Establishment Section</p>
                                            </td>
                                            <td>Convenor</td>
                                        </tr>
                                       
                                    </tbody>

                                </Table>

                               


                                <p className='fw-bold c-headline caboutus mt-3 mb-3'>Terms of Reference:</p>
                                
                                <ul className='ms-3 c-lineheight2dot5 iarrow caboutus' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> To receive and examine grievances of Teaching and Non-Teaching staff relating to workplace concerns, harassment, unfair treatment, service matters, or any related issues.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	To ensure that complaints are handled with confidentiality, impartiality, and due diligence. </li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	To recommend remedial measures or further action to the competent Authority.</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" />	To maintain records of complaints received and their disposal.</li>
                                    
                                </ul>

                                 <p className='fw-bold c-headline caboutus mt-3 mb-3'>The grievances can be submitted by either of the following modes:</p>
                                
                                <ul className='myulcustarrow caboutus'>
                                  
                                    <li> Email to:
                                        <ul className='myulcustarrow caboutus'>
                                            <li> Teaching Staff: <b>grievance.faculty@iittp.ac.in</b></li>
                                    <li>	Non-teaching Staff: <b>grievance.staff@iittp.ac.in</b></li>
                                        </ul>
                                     </li>
                                    <li>Direct written submission to the Convener in a sealed cover marked "Confidential-Grievance Submission".</li>
                                     </ul>
                                
                                <p className='fw-bold c-headline caboutus mt-3 mb-3'>The complaint should contain the following details:</p>
                                
                                <ul className='ms-3 c-lineheight2dot5 iarrow caboutus' >
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Name, Employee ID., Department/Section, and Contact Details</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Nature of grievance/complaint (brief and factual description)</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Persons involved (if any)</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Supporting documents or evidence (if applicable)</li>
                                    <li><i className="fal fa-arrow-alt-circle-right me-3 c-link" /> Relief or resolution sought</li>
                                     
                                </ul>

                                 <p className='fw-bold c-headline caboutus mt-3 mb-3'>Complainants are encouraged to submit their grievances in a respectful, factual, and concise manner. The identity of complainants and the details of the complaint will be treated with strict confidentiality.</p>

                                </Col>

                           
                        </Row>

                    </div>
                </div>
            </section>
        </>
    )
}

export default Main;